/*
  AYO budget finder (sections/ayo-budget-finder.liquid).
  Reads the collection once (sections/ayo-size-index.liquid, only when the section comes near the screen),
  then the slider and the size buttons filter it instantly in the browser.
*/
(function () {
  if (customElements.get('ayo-budget-finder')) return;
  const esc = (s) => String(s == null ? '' : s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const fill = (t, o) => String(t || '').replace(/\[(\w+)\]/g, (m, k) => (k in o ? o[k] : m));
  const moneyFmt = (cents, format) => {
    const f = (n, dec, th, ds) => { const [i, d] = (n / 100).toFixed(dec).split('.'); return i.replace(/\B(?=(\d{3})+(?!\d))/g, th) + (d ? ds + d : ''); };
    return String(format || 'LE {{amount}}').replace(/\{\{\s*(\w+)\s*\}\}/, (m, k) => {
      if (k === 'amount_no_decimals') return f(cents, 0, ',', '.');
      if (k === 'amount_with_comma_separator') return f(cents, 2, '.', ',');
      if (k === 'amount_no_decimals_with_comma_separator') return f(cents, 0, '.', ',');
      return f(cents, 2, ',', '.');
    }).replace(/[.,]00(?=\D*$)/, '');
  };
  const short = (v) => (v >= 1000 ? `${(v / 1000).toString().replace(/\.0$/, '')}K` : String(v));

  class AyoBudgetFinder extends HTMLElement {
    connectedCallback() {
      this.min = parseInt(this.dataset.min, 10) || 0;
      this.max = parseInt(this.dataset.max, 10) || 10000;
      this.step = parseInt(this.dataset.step, 10) || 100;
      this.limit = parseInt(this.dataset.limit, 10) || 12;
      this.range = this.querySelector('[data-ayo-bf-range]');
      this.row = this.querySelector('[data-ayo-bf-row]');
      this.size = '';
      this.items = null;
      this.M = (egp) => moneyFmt(Math.round(egp * 100), this.dataset.money);
      const minEl = this.querySelector('[data-ayo-bf-min]'); if (minEl) minEl.textContent = this.M(this.min);
      const maxEl = this.querySelector('[data-ayo-bf-max]'); if (maxEl) maxEl.textContent = this.M(this.max);
      this.querySelectorAll('[data-ayo-bf-qlabel]').forEach((el) => { el.textContent = short(parseInt(el.dataset.ayoBfQlabel, 10)); });
      this.range.addEventListener('input', () => this.update());
      this.addEventListener('click', (e) => this.onClick(e));
      this.paintTop();
      // Read the products only when the section is about to be seen.
      if (this.dataset.design === 'true' || !('IntersectionObserver' in window)) { this.load(); return; }
      this.io = new IntersectionObserver((en) => { if (en.some((x) => x.isIntersecting)) { this.io.disconnect(); this.load(); } }, { rootMargin: '600px 0px' });
      this.io.observe(this);
    }

    disconnectedCallback() { if (this.io) this.io.disconnect(); }

    get budget() { return parseInt(this.range.value, 10) || this.max; }

    async load() {
      this.say(this.dataset.tLoading);
      const pages = Math.max(1, Math.min(4, parseInt(this.dataset.pages, 10) || 2));
      const key = `ayo-bf:${this.dataset.url}:${pages}`;
      try {
        let items = null;
        try { const c = sessionStorage.getItem(key); if (c) { const o = JSON.parse(c); if (Date.now() - o.t < 10 * 60 * 1000) items = o.items; } } catch (e) { /* no storage */ }
        if (!items) {
          const get = async (p) => {
            const res = await fetch(`${this.dataset.url}?section_id=ayo-size-index&page=${p}`);
            if (!res.ok) throw new Error(String(res.status));
            const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
            const s = doc.querySelector('[data-ayo-size-index]');
            if (!s) throw new Error('no data');
            return JSON.parse(s.textContent);
          };
          const first = await get(1);
          const rest = [];
          for (let p = 2; p <= Math.min(first.pages || 1, pages); p += 1) rest.push(get(p));
          const more = await Promise.all(rest);
          items = first.items.concat(...more.map((x) => x.items)).filter((p) => p.a);
          try { sessionStorage.setItem(key, JSON.stringify({ t: Date.now(), items })); } catch (e) { /* full or blocked */ }
        }
        this.items = items;
        this.update();
      } catch (e) {
        this.items = [];
        this.say('');
        this.row.innerHTML = '';
        this.closest('.shopify-section').hidden = !(this.dataset.design === 'true');
      }
    }

    onClick(e) {
      const q = e.target.closest('[data-ayo-bf-quick]');
      if (q) { this.range.value = q.dataset.ayoBfQuick; this.update(); return; }
      const z = e.target.closest('[data-ayo-bf-size]');
      if (z) { const v = z.dataset.ayoBfSize; this.size = this.size === v ? '' : v; this.update(); return; }
      if (e.target.closest('[data-ayo-bf-clear]')) { this.size = ''; this.update(); return; }
      const next = e.target.closest('[data-ayo-bf-next]');
      if (next) { this.range.value = String(Math.min(this.max, Math.ceil(parseInt(next.dataset.ayoBfNext, 10) / this.step) * this.step)); this.update(); return; }
      const add = e.target.closest('[data-ayo-bf-add]');
      if (add) this.add(add);
    }

    paintTop() {
      const b = this.budget;
      const pct = ((b - this.min) * 100) / Math.max(1, this.max - this.min);
      this.range.style.setProperty('--pct', `${pct}%`);
      const val = this.querySelector('[data-ayo-bf-value]');
      if (val) {
        val.textContent = b >= this.max && this.dataset.tAny ? this.dataset.tAny : this.M(b);
        val.classList.remove('is-bump'); void val.offsetWidth; val.classList.add('is-bump');
      }
      this.querySelectorAll('[data-ayo-bf-quick]').forEach((q) => q.classList.toggle('is-on', parseInt(q.dataset.ayoBfQuick, 10) === b));
      this.querySelectorAll('[data-ayo-bf-size]').forEach((x) => x.setAttribute('aria-pressed', x.dataset.ayoBfSize === this.size ? 'true' : 'false'));
      const clear = this.querySelector('[data-ayo-bf-clear]'); if (clear) clear.hidden = !this.size;
      const all = this.querySelector('[data-ayo-bf-all]');
      if (all) {
        const u = new URL(this.dataset.url, window.location.origin);
        if (b < this.max) u.searchParams.set('filter.v.price.lte', String(b));
        if (this.size) u.searchParams.set('size', this.size);
        all.setAttribute('href', u.pathname + u.search);
      }
    }

    say(text) { const c = this.querySelector('[data-ayo-bf-count]'); if (c) c.innerHTML = text || ''; }

    update() {
      this.paintTop();
      if (!this.items) return;
      const b = this.budget * 100;
      const anyPrice = this.budget >= this.max;
      const z = this.size;
      const inSize = (p) => !z || (p.s || []).indexOf(z) > -1;
      const fit = this.items.filter((p) => (anyPrice || p.n <= b) && inSize(p)).sort((x, y) => y.n - x.n);
      const n = fit.length;
      this.say(n ? fill(z ? this.dataset.tCountSize : this.dataset.tCount, { count: `<b>${n}</b>`, size: esc(z) }) : '');
      if (!n) {
        const above = this.items.filter((p) => p.n > b && inSize(p)).sort((x, y) => x.n - y.n)[0];
        const msg = esc(fill(z ? this.dataset.tNoneSize : this.dataset.tNone, { size: z }));
        const btn = above ? `<button type="button" class="ayo-bf__next" data-ayo-bf-next="${Math.ceil(above.n / 100)}">${esc(fill(this.dataset.tNext, { price: above.p.replace(/[.,]00(?=\D*$)/, ''), name: above.t }))}</button>` : '';
        this.row.innerHTML = `<div class="ayo-bf__none">${msg}${btn}</div>`;
        return;
      }
      this.row.innerHTML = fit.slice(0, this.limit).map((p) => this.card(p)).join('');
    }

    card(p) {
      const z = this.size;
      const vi = z ? (p.s || []).indexOf(z) : -1;
      const vid = vi > -1 && p.vs ? p.vs[vi] : 0;
      const tag = z && vi > -1 ? `<span class="ayo-card__badge ayo-bf__fit">${esc(z)} ✓</span>` : (p.o > 0 ? `<span class="ayo-card__badge">-${p.o}%</span>` : '');
      const img = p.i ? `<img src="${esc(p.i)}" alt="${esc(p.al || p.t)}" loading="lazy" width="600" height="750" class="ayo-card__img">` : '';
      const wish = this.dataset.wish === 'true' ? `<wishlist-button class="ayo-card__wish" data-id="${p.id}" data-product-handle="${esc(p.h)}" role="button" tabindex="0" aria-label="${esc(this.dataset.tWish)}"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round" aria-hidden="true"><path d="M12 20s-7-4.4-7-10a4 4 0 017-2.6A4 4 0 0119 10c0 5.6-7 10-7 10z"/></svg></wishlist-button>` : '';
      const add = vid ? `<button type="button" class="ayo-bf__add" data-ayo-bf-add="${vid}" aria-label="${esc(fill(this.dataset.tAdd, { size: z }))}: ${esc(p.t)}">+</button>` : '';
      return `<div class="ayo-card ayo-bf__card"><div class="ayo-card__media"><a href="${esc(p.u)}" class="ayo-card__img-link" tabindex="-1" aria-hidden="true">${img}</a>${tag}${wish}${add}</div><a href="${esc(p.u)}" class="ayo-card__title">${esc(p.t)}</a><div class="ayo-card__price"><span>${esc(p.p)}</span>${p.c ? `<s>${esc(p.c)}</s>` : ''}</div></div>`;
    }

    async add(btn) {
      if (btn.classList.contains('is-loading') || btn.classList.contains('is-added')) return;
      btn.classList.add('is-loading');
      const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
      const body = { items: [{ id: parseInt(btn.dataset.ayoBfAdd, 10), quantity: 1 }] };
      if (cart && typeof cart.getSectionsToRender === 'function') { body.sections = cart.getSectionsToRender().map((x) => x.id); body.sections_url = window.location.pathname; }
      try {
        const res = await fetch(`${(window.routes && window.routes.cart_add_url) || '/cart/add'}.js`.replace('.js.js', '.js'), { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) });
        const data = await res.json();
        if (!res.ok || data.status) throw new Error(data.description || '');
        if (cart && data.sections && typeof cart.getSectionsToRender === 'function') {
          cart.getSectionsToRender().forEach((sec) => {
            const html = data.sections[sec.id]; if (!html) return;
            const el = sec.selector ? document.querySelector(sec.selector) : document.getElementById(sec.id); if (!el) return;
            const src = new DOMParser().parseFromString(html, 'text/html').querySelector(sec.selector || '.shopify-section');
            if (src) el.innerHTML = src.innerHTML;
          });
          cart.classList.remove('is-empty');
        }
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate, { source: 'ayo-budget-finder', productVariantId: btn.dataset.ayoBfAdd, cartData: data });
        document.dispatchEvent(new CustomEvent('ayo:cart-changed'));
        btn.classList.add('is-added');
        btn.textContent = '✓';
        btn.setAttribute('aria-label', this.dataset.tAdded || '');
      } catch (e) {
        btn.classList.add('is-error');
        setTimeout(() => btn.classList.remove('is-error'), 1200);
      } finally {
        btn.classList.remove('is-loading');
      }
    }
  }
  customElements.define('ayo-budget-finder', AyoBudgetFinder);
})();
